module.exports = __webpack_public_path__ + "img/bg.37e6518e.jpg";